@use '../../../../styles/scss/vcom/themes/classic/colors' as classic;

.vs-amb-video-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  place-items: center;
}

.vs-amb-video-container {
  position: relative;
  .vs-amb-video {
    position: relative;
    object-fit: cover;
  }

  .vs-amb-video-btn {
    position: absolute;
    width: 43px;
    height: 43px;
  }
}

.vs-amb-video-play-btn {
  &::after {
    content: '\e944';
  }
}

.vs-amb-video-pause-btn {
  &::after {
    content: '\e943';
  }
}

.vs-amb-video-pause-btn,
.vs-amb-video-play-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'visa-icon', sans-serif;
  font-size: 19px;
  border-radius: 50%;

  /* START GENAI@GHCOPILOT */
  &.vs-amb-video-btn-white {
    background-color: black;
    /* START GENAI@GHCOPILOT */
    box-shadow: 0 0 0 3px #{classic.$vs-black};
    /* END GENAI@GHCOPILOT */
    color: white;
    color: #{classic.$vs-white};
    border: 2px solid white;
    border: 2px solid #{classic.$vs-white};

    &:hover,
    &:focus {
      background-color: #2c2c2c;
      background-color: #{classic.$vs-tertiary-7};
      opacity: 0.8;
    }

    &:focus {
      outline: 1px dashed white;
      outline: 1px dashed #{classic.$vs-white};
      outline-offset: -5px;
    }
  }

  &.vs-amb-video-btn-black {
    background-color: white;
    background-color: #{classic.$vs-white};
    box-shadow: 0 0 0 3px white;
    box-shadow: 0 0 0 3px #{classic.$vs-white};
    color: #2c2c2c;
    color: #{classic.$vs-tertiary-7};
    border: 2px solid #2c2c2c;
    border: 2px solid #{classic.$vs-tertiary-7};

    &:hover,
    &:focus {
      opacity: 0.8;
    }

    &:focus {
      outline: 1px dashed #2c2c2c;
      outline: 1px dashed #{classic.$vs-tertiary-7};
      outline-offset: -5px;
    }
  }
  /* END GENAI@GHCOPILOT */
}

.vs-amb-video-container .vs-amb-video-btn {
  right: 15px;
  top: 11px;
}


